export default "__VITE_ASSET__Dvq9Rjmg__";